import { serializeParam, objectAssign } from '@tencent/midas-util';
import sessionToken from './sessionToken';

var _pid = 0;
function getPid() {
  return _pid++;
}

/**
 * @param {Object} param 需要上报的字段
 * @param[21] 必传，iformat
 * @param[31] 必传，版本号，如exampleV0.1
 * @param[8] resultinfo
 * @param[3] 登录态的openid
 * @param[37] 登录态session_id
 * @param[43] 登录态的session_type
 * @param[41] 微信登录态对应的微信appid
 * @param[19] 大写的业务代码
 * @param[24] offerid
 * @param[26] pf，需要报三段式的
 * @param[7] 错误码，默认0，错误上报时可通过该字段区分错误类型
 */
export default function (param = {}, opt = {}, reportUrl) {
  var _p = window.webkitPerformance || window.performance;
  if (!param[21]) {
    throw new Error('logdata需要21字段(iformat)');
  }
  if (!param[31]) {
    throw new Error('logdata需要31字段(版本号)');
  }

  var resultinfo = '';
  if (typeof param[8] === 'object') {
    resultinfo = serializeParam(param[8], true)
  } else if (param[8]) {
    resultinfo = param[8];
  }

  param = objectAssign({
    7: 0,
    29: sessionToken
  }, param, {
      6: 10,
      8: encodeURIComponent(resultinfo),
      13: _pid++,
      35: _p && _p.timing && _p.timing.navigationStart ? _p.timing.navigationStart : '',
      36: encodeURIComponent(location.href.split('#')[0]),
      38: new Date().getTime(),
      42: typeof document.referrer === "string" ? encodeURIComponent(document.referrer.substr(0, 1000)) : '',
      50: navigator.userAgent
    })
  var pu = [];
  for (var k in param) {
    pu.push(k + "=" + encodeURIComponent(param[k]));
  }
  var pu2 = [];
  for (var k in opt) {
    pu2.push("&" + k + "=" + encodeURIComponent(opt[k]));
  }

  setTimeout(function () {
    var url = reportUrl || "https://szmg.qq.com/cgi-bin/log_data.fcg";
    var req = (function () {
      if (window.XMLHttpRequest) {
        var _xhr = new XMLHttpRequest();
        if ("withCredentials" in _xhr) {
          return _xhr
        }
      }
      if (typeof XDomainRequest != "undefined") {
        return new XDomainRequest();
      }
      return null;
    })()
    if (req) {
      try {
        req.open('POST', url, true);
        req.onerror = function () { };
        req.onreadystatechange = function () { };
        if (req.setRequestHeader) {
          req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        }
        req.timeout = 10000;
        req.send("offer_id=15499&num=1&record0=" + encodeURIComponent(pu.join('|')) + pu2.join("") + "&rr=" + Math.random());
      } catch (e) { }
    }
  }, 0);
}
